import axios from 'axios'
import getPromotions from '../modules/getPromotions'

/**
 * Gets all organization promotions that the authenticated admin has access to.
 */
export default function getAdminPromotions ({ commit, state }) {
  axios.get(`${process.env.VUE_APP_API_URL}api/promotions`, {
    headers: {
      'x-access-token': localStorage.getItem('user-token')
    }
  })
    .then(function (response) {
      commit('updatePromotions', getPromotions(response.data.data))
    })
    .catch(function (error) {
      console.log(error)
    })
}
